"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pencil = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const pencil = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'pencil-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', 
            // eslint-disable-next-line max-len
            d: 'M16.921 3.64036C17.9952 4.71452 17.9943 6.45619 16.9206 7.52991L8.43575 16.0147C8.33105 16.1194 8.1977 16.1908 8.05251 16.2198L4.51697 16.9269C4.27108 16.9761 4.01687 16.8991 3.83956 16.7218C3.66224 16.5445 3.58527 16.2903 3.63445 16.0444L4.34156 12.5089C4.3706 12.3637 4.44196 12.2303 4.54666 12.1256L13.0319 3.64036C14.1059 2.56641 15.8471 2.56641 16.921 3.64036ZM15.8599 6.46925C16.3483 5.98086 16.3483 5.18895 15.8604 4.70102C15.3722 4.21286 14.5808 4.21286 14.0926 4.70102L5.76789 13.0257L5.32595 15.2354L7.53566 14.7935L15.8599 6.46925Z', fill: '#4B5563' })));
};
exports.pencil = pencil;
